import React, { createContext, useContext, useState, ReactNode } from 'react';
import { EventType } from '../types';

interface BookingContextType {
  isModalOpen: boolean;
  selectedEventType: EventType | null;
  selectedDate: string;
  quickDate: string;
  quickType: EventType | '';
  setQuickDate: (date: string) => void;
  setQuickType: (type: EventType | '') => void;
  openModal: (type?: EventType, date?: string) => void;
  closeModal: () => void;
}

const BookingContext = createContext<BookingContextType | undefined>(undefined);

export const BookingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEventType, setSelectedEventType] = useState<EventType | null>(null);
  const [selectedDate, setSelectedDate] = useState('');
  
  // Quick Book State (Shared across all Quick Bars)
  const [quickDate, setQuickDate] = useState('');
  const [quickType, setQuickType] = useState<EventType | ''>('');

  const openModal = (type?: EventType, date?: string) => {
    setSelectedEventType(type || (quickType as EventType) || null);
    setSelectedDate(date || quickDate || '');
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <BookingContext.Provider
      value={{
        isModalOpen,
        selectedEventType,
        selectedDate,
        quickDate,
        quickType,
        setQuickDate,
        setQuickType,
        openModal,
        closeModal,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (context === undefined) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};